import { RouteObject } from 'react-router/dist/lib/context';
import { ItsmMaintenanceWorks, ItsmNetworkServiceIncidents } from './components';

export enum ItsmRoutes {
  Incidents = 'incidents',
  MaintenanceWorks = 'maintenance-works',
}

export const itsmRoutes: RouteObject[] = [
  {
    path: ItsmRoutes.MaintenanceWorks,
    element: <ItsmMaintenanceWorks />,
  },
  {
    path: ItsmRoutes.Incidents,
    element: <ItsmNetworkServiceIncidents />,
  },
];
